import { SortDescriptor } from "@progress/kendo-data-query";

export class SortField {
    constructor(public field: string, public isDescending: boolean) {

    }
 
    static fromSortDescriptor(sortDescriptor: SortDescriptor) {
        return new SortField(sortDescriptor.field, sortDescriptor.dir === 'asc' ? true : false)
    }
}